(ns ui.chip
  (:require ["lucide-react" :refer [X]]
            [ui.utils :refer [clsx separate-props]]))

(defn classes [{:keys [class variant]}]
  (clsx "text-xs rounded-full border  px-2 py-px inline-flex items-center gap-0.5"
        (case variant
          :success "border-kleene-text-success/75 text-kleene-text-success"
          :success-filled "border-transparent bg-kleene-text-success text-white"
          :error "border-kleene-text-error/75 text-kleene-text-error"
          :warning "border-kleene-text-warning/75 bg-kleene-text-warning/15 text-kleene-text-warning"
          :main "text-white bg-kleene-secondary-02 dark:bg-kleene-secondary-v2"
          :secondary-border "border-kleene-secondary-01/50 text-kleene-secondary-01 dark:border-kleene-input-border dark:text-kleene-text"
          :secondary "border-transparent bg-kleene-secondary-01/10 text-kleene-secondary-01 dark:bg-kleene-secondary-v2/10 dark:text-kleene-secondary-v2/90"
          "border-kleene-secondary-01/50 text-kleene-secondary-01 dark:border-kleene-input-border/25 dark:text-kleene-text")
        class))

(defn chip [& args]
  (let [[props children] (separate-props args)
        {:keys [on-delete icon]} props]
    [:div {:class (classes props)}
     icon
     (into [:span] children)
     (when on-delete
       [:div {:class    "cursor-pointer hover:text-kleene-error-01 leading-zero"
              :on-click on-delete}
        [:> X {:size 16 :class "leading-zero"}]])]))
